export default __webpack_public_path__ + "static/media/check.6348cd58.svg";